import { makeStyles, Box } from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import ChartStatistic from 'src/app/components/ChartStatistic/ChartStatistic';
import ToolBarStatistic from 'src/app/components/ToolBarStatistic/ToolBarStatistic';
import StatisticDeviceActiveTable from './StatisticDeviceActiveTable';
import {
  getStatisticDeviceActive,
  getStatisticWarehouseTransfer,
  postExportStatisticActive
} from 'src/features/statisticSlice';
import { PAGE_SIZE_LIST } from 'src/app/constant/config';
import { useQuery } from 'src/app/hooks/useQuery';
import { _convertObjectToQuery } from 'src/app/utils/apiService';
import { useTheme, useMediaQuery } from '@material-ui/core';

const StatisticDeviceActive = () => {
  const dispatch = useDispatch();
  const classes = useStyles();
  const navigate = useNavigate();

  const theme = useTheme();
  const query = useQuery();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), {
  noSsr: true
});
  const [params, setParams] = useState({
    page: 1,
    page_size: isMobile ? 4 : PAGE_SIZE_LIST,
    time_to_chart: 2026,
    time_to_search: 2026
  });

  const listDeviceActive = useSelector(
    state => state.statisticSlice.listDeviceActive
  );
  const monthlyStatisticsActive = useSelector(
    state => state.statisticSlice.monthlyStatisticsActive
  );
  const yearlyStatisticsActive = useSelector(
    state => state.statisticSlice.yearlyStatisticsActive
  );
  const monthlyStatisticsTrans = useSelector(
    state => state.statisticSlice.monthlyStatisticsTrans
  );
  const yearlyStatisticsTrans = useSelector(
    state => state.statisticSlice.yearlyStatisticsTrans
  );

  const totalActive = useSelector(state => state.statisticSlice.totalActive);

  const page = query.get('page') || 1;
  const agencyId = query.get('agency_id') || undefined;
  const deviceTypeId = query.get('device_type_id') || undefined;
  const timeToChart = query.get('time_to_chart') || 2026;
  const timeToSearch = query.get('time_to_search') || 2026;

  const dataStatisticsActive = timeToChart
    ? monthlyStatisticsActive
    : yearlyStatisticsActive;
  const dataStatisticsTransfer = timeToChart
    ? monthlyStatisticsTrans
    : yearlyStatisticsTrans;

  // useEffect(() => {
  //   dispatch(getStatisticDeviceActive(params));
  // }, []);
  useEffect(() => {
    const newParams = {
      ...params,
      page: 1,
      page_size: isMobile ? 4 : PAGE_SIZE_LIST
    };
    setParams(newParams);
    dispatch(getStatisticDeviceActive(newParams));
    dispatch(getStatisticWarehouseTransfer(newParams));
  }, [isMobile]);
  useEffect(() => {
    const queryValue = {
      ...params,
      page: page ? page : undefined,
      agency_id: agencyId ? agencyId : undefined,
      device_type_id: deviceTypeId ? deviceTypeId : undefined,
      time_to_chart: timeToChart ? timeToChart : undefined,
      time_to_search: timeToSearch ? timeToSearch : undefined
    };
    setParams(queryValue);
  }, [query]);

  const getListDeviceActiveWithParams = data => {
    navigate('/app/manage/statistics/active?' + _convertObjectToQuery(data));
    dispatch(getStatisticDeviceActive(data));
    dispatch(getStatisticWarehouseTransfer(data));
  };

  const exportStatistic = data => {
    dispatch(postExportStatisticActive(data));
  };

  return (
    <>
      <div className={classes.root}>
        <div style={{ width: '98%', margin: '0 auto' }}>
          <Box
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '4px',
              padding: '0px 10px 5px'
            }}
          >
            <ChartStatistic
              chartTitle={'Thống kê chuyển kho và kích hoạt'}
              datasets={[
                {
                  label: 'Thống kê chuyển kho',
                  data: dataStatisticsTransfer,
                  backgroundColor: '#2d9aff'
                },
                {
                  label: 'Thống kê kích hoạt',
                  data: dataStatisticsActive,
                  backgroundColor: '#D9042F'
                }
              ]}
              searchRef={getListDeviceActiveWithParams}
            />
          </Box>
          <Box marginTop={isMobile ? '12px' : '20px'}>
            <ToolBarStatistic
              devicesCount={`${totalActive} thiết bị`}
              isTransfer={false}
              exportStatistic={exportStatistic}
            />
          </Box>
          <Box marginTop={'10px'}>
            <StatisticDeviceActiveTable
              listDeviceActive={listDeviceActive}
              totalActive={totalActive}
              getListDeviceActiveRef={getListDeviceActiveWithParams}
              params={params}
              setParams={setParams}
            />
          </Box>
        </div>
      </div>
    </>
  );
};

const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    display: 'flex',
    // height: '100%',
    width: '100%',
    marginBottom: 30
  },
  wrapper: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 auto',
    overflow: 'hidden',
    [theme.breakpoints.up('lg')]: {
      paddingLeft: 256
    }
  },
  contentContainer: {
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
  },
  content: {
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
  }
}));

export default StatisticDeviceActive;
